import { Button, Checkbox, Col, Form, message, Modal, Row } from "antd";
import React, { useState } from "react";
import { post } from "../../apiService";
import { IoSettings } from "react-icons/io5";

export default function PrevilageUpdate({ data }) {
  const [openControl, setOpenControl] = useState(false);

  const [handleCheck, setHandleCheck] = useState({
    product_add: data.product_add === "1",
    product_update: data.product_price_update === "1",
    product_price_update: data.product_update === "1",
  });

  const updateControl = async () => {
    try {
      const formData = new FormData();
      formData.append("product_add", handleCheck.product_add ? "1" : "0");
      formData.append("product_update", handleCheck.product_update ? "1" : "0");
      formData.append(
        "product_price_update",
        handleCheck.product_price_update ? "1" : "0"
      );
      formData.append("user_id", data.user_id);
      formData.append("action", "update_profile");
      const response = await post("/user.php", formData);
      if (response) {
        message.success("Previllage Update Successfully");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <Button
        className="bg-dark text-white"
        icon={<IoSettings />}
        onClick={() => setOpenControl(true)}
      >
        Control
      </Button>
      <Modal
        title="Update Control"
        open={openControl}
        footer={[]}
        centered
        onCancel={() => setOpenControl(false)}
        className="component-modal"
      >
        <Form onFinish={updateControl}>
          <Row>
            <Col span={8}>
              <Checkbox
                checked={handleCheck.product_add}
                onChange={(e) =>
                  setHandleCheck((prev) => ({
                    ...prev,
                    product_add: !prev.product_add,
                  }))
                }
              >
                Add Product
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                checked={handleCheck.product_update}
                onChange={(e) =>
                  setHandleCheck((prev) => ({
                    ...prev,
                    product_update: !prev.product_update,
                  }))
                }
              >
                Update Product
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                checked={handleCheck.product_price_update}
                onChange={(e) =>
                  setHandleCheck((prev) => ({
                    ...prev,
                    product_price_update: !prev.product_price_update,
                  }))
                }
              >
                Update Price
              </Checkbox>
            </Col>
          </Row>

          <div className="buttonGroup mt-5 d-flex justify-content-end">
            <Button className="mx-3 bg-dark text-white">Cancel</Button>
            <Button htmlType="submit" className="bg-success text-white">
              Update
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
}
